import Store from 'store/store';
import { getCurrentRegion } from 'utils/studioConfig';

const ALL_PERMISSIONS = Symbol('all');

// Permissions should match backend
const roles = {
	super_admin: { level: 5, permissions: ALL_PERMISSIONS, name: 'Global Admin' },
	admin: { level: 4, permissions: new Set(['read', 'write', 'publish', 'upload', 'user_manage']), name: 'Admin' },
	publisher: { level: 3, permissions: new Set(['read', 'write', 'publish', 'upload']), name: 'Publisher' },
	editor: { level: 2, permissions: new Set(['read', 'write', 'upload']), name: 'Editor' },
	viewer: { level: 1, permissions: new Set(['read']), name: 'Viewer' },
};

export const allRoles = Object.keys(roles).sort((a, b) => roles[b].level - roles[a].level);

export function getRoleName(role = getUserRole()) {
	return roles[role]?.name || role;
}

export function getUserRole() {
	const user = Store.get().user;
	const region = getCurrentRegion();

	return region?.role_name || user?.role;
}

export function canUser(permission) {
	const currentRole = getUserRole();
	if (!currentRole) return false;
	return canRole(permission, currentRole);
}

export function canRole(permission, role) {
	const permissions = roles[role]?.permissions;
	if (permissions === ALL_PERMISSIONS) return true;
	return !!permissions && permissions.has(permission);
}

export function getRoleLevel(role = getUserRole()) {
	return roles[role]?.level || 0;
}

export function isPowsterEmployee() {
	const user = Store.get().user;
	return !!user?.is_powster_employee;
}

export function hasGlobalAdminAccess() {
	if (isPowsterEmployee()) return true;
	return getUserRole() === 'super_admin';
}